// MULTILINE
export const MULTILINE_CHARACTER_LIMIT = 255;
// Character limit if selected "attach to form name" setting
export const ATTACH_TO_FORM_NAME_MULTILINE_CHARACTER_LIMIT = 120;
